<!-- Section for vital information in the memorial guide -->
<template>
	<div class="bg-primary-25 w-full p-6 pb-2 print:pt-6">
		<h2
			class="form-title pb-6 text-2xl font-bold print:mb-3 print:border-b-2 print:border-slate-900 print:pt-2 print:pb-3 print:text-sm/0"
		>
			{{ t('plan.sectionTitle.vitalInfo') }}
			<span class="font-normal italic">
				{{ t('plan.sectionSubtitle.usedForDeathCertificate') }}
			</span>
		</h2>

		<section>
			<div
				class="section-grid-row grid grid-cols-4 gap-2 *:w-full *:max-w-none"
			>
				<FormKit
					type="textarea"
					auto-height
					name="firstName"
					:label="t('person.firstName')"
				/>

				<FormKit
					type="textarea"
					auto-height
					name="middleName"
					:label="t('person.middleName')"
				/>

				<FormKit
					type="textarea"
					auto-height
					name="lastName"
					:label="t('person.lastName')"
				/>

				<FormKit
					v-if="!truncate"
					type="textarea"
					auto-height
					name="maidenName"
					:label="t('person.maidenName')"
				/>
			</div>

			<CopyButtonList
				:field-or-section="[
					'address',
					'city',
					'state',
					'zip',
					'phone',
					'email',
				]"
				:active-index="activePlanIndex"
				class="print:hidden"
			/>

			<div
				class="section-grid-row grid grid-cols-4 gap-2 *:w-full *:max-w-none"
			>
				<FormKit
					type="textarea"
					auto-height
					name="address"
					:label="t('person.address')"
				/>

				<FormKit
					type="textarea"
					auto-height
					name="city"
					:label="t('person.city')"
				/>

				<FormKit
					type="autocomplete"
					:label="t('person.state')"
					name="state"
					:placeholder="
						t('plan.placeholders.select', {
							placeholderLabel: t('person.state'),
						})
					"
					:options="stateOptions"
					clear-search-on-open
				/>

				<FormKit
					type="text"
					name="zip"
					:label="t('person.zip')"
					validation="matches: /^\d{5}(-\d{4})?$/"
					validation-visibility="live"
				/>
			</div>

			<div
				class="section-grid-row grid grid-cols-2 *:w-full *:max-w-none *:px-1 *:pb-1"
			>
				<FormKit
					type="tel"
					name="phone"
					:label="t('person.phone')"
					placeholder="xxx-xxx-xxxx"
					:validation="[['matches', /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/]]"
					:validation-messages="{
						matches: `${t('plan.validationMessages.phone')}`,
					}"
					validation-visibility="live"
				/>
				<FormKit
					type="email"
					:label="t('person.email')"
					name="email"
					validation="email"
					validation-visibility="dirty"
					:placeholder="t('plan.placeholders.email')"
				/>
			</div>

			<slot></slot>
		</section>
	</div>
</template>

<script setup lang="ts">
import CopyButtonList from '@/components/presentation/CopyButtonList.vue'
import { stateOptions } from '@/data/stateOptions'
import { usePresentationLocale } from '@/i18n'
import { FormKit } from '@formkit/vue'

const { t } = usePresentationLocale()

defineProps<{
	activePlanIndex: number
	truncate: Boolean
}>()
</script>
